import qsRequest from "@/api/qsRequest";

export async function getCates() {
    const res = await qsRequest({
        method: "get",
        url: "/cate"
    })
    const {data} = res.data
    return {
        cates: data
    }
}